<lib-renderer-container
  [params]="params"
  [className]="isNegativeCurrency() ? 'negative-currency-red': 'positive-currency'"
>
  {{ params.value?.value }}
</lib-renderer-container>
